import { IProduct } from "@faire/web-api/indigofair/data/IProduct";

export const shouldShowPromotedBadge = (
  is_promoted: boolean | undefined,
  promoted_by: Array<keyof typeof IProduct.PromotedType>
) => {
  if (!is_promoted) {
    return false;
  }

  return promoted_by.includes(IProduct.PromotedType.ADS);
};
